// 1.

// import React, { useEffect, useState } from "react";

// const WeatherTable = () => {
//   const [weatherData, setWeatherData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [city, setCity] = useState("Delhi");       // default city
//   const [inputCity, setInputCity] = useState("");  // input box

//   const API_KEY = "4445f64ee2f2796463cb66204fdae4ce";

//   useEffect(() => {
//     fetchWeather(city);
//   }, [city]);

//   const fetchWeather = async (cityName) => {
//     setLoading(true);

//     try {
//       const res = await fetch(
//         `https://api.openweathermap.org/data/2.5/forecast?q=${cityName}&appid=${API_KEY}&units=metric`
//       );

//       const data = await res.json();

//       // ❗ Safe check
//       if (!data || !data.list) {
//         setWeatherData({});
//         setLoading(false);
//         return;
//       }

//       // 🔥 Group data by date
//       const grouped = {};

//       data.list.forEach((item) => {
//         const date = item.dt_txt.split(" ")[0];

//         if (!grouped[date]) {
//           grouped[date] = [];
//         }

//         grouped[date].push(item);
//       });

//       setWeatherData(grouped);
//     } catch (err) {
//       console.error("Error:", err);
//       setWeatherData({});
//     }

//     setLoading(false);
//   };

//   // 🔍 Handle Search
//   const handleSearch = () => {
//     if (inputCity.trim() !== "") {
//       setCity(inputCity);
//       setInputCity("");
//     }
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>🌤 Weather Forecast ({city})</h2>

//       {/* 🔍 Search Box */}
//       <div style={{ marginBottom: "15px" }}>
//         <input
//           type="text"
//           placeholder="Enter city..."
//           value={inputCity}
//           onChange={(e) => setInputCity(e.target.value)}
//           style={{ padding: "8px", width: "200px" }}
//         />
//         <button
//           onClick={handleSearch}
//           style={{ padding: "8px 12px", marginLeft: "10px" }}
//         >
//           Search
//         </button>
//       </div>

//       {loading && <p>Loading...</p>}

//       {!loading && Object.keys(weatherData).length > 0 && (
//         <table
//           border="1"
//           cellPadding="10"
//           style={{ width: "100%", borderCollapse: "collapse" }}
//         >
//           <thead>
//             <tr style={{ background: "#f2f2f2" }}>
//               <th>Date</th>
//               <th>Temp (°C)</th>
//               <th>Min Temp</th>
//               <th>Max Temp</th>
//               <th>Humidity</th>
//               <th>Weather</th>
//               <th>Wind Speed</th>
//             </tr>
//           </thead>

//           <tbody>
//             {Object.keys(weatherData).map((date) => {
//               const day = weatherData[date][0];

//               return (
//                 <tr key={date}>
//                   <td>{date}</td>
//                   <td>{day.main?.temp}</td>
//                   <td>{day.main?.temp_min}</td>
//                   <td>{day.main?.temp_max}</td>
//                   <td>{day.main?.humidity}%</td>
//                   <td>{day.weather?.[0]?.description}</td>
//                   <td>{day.wind?.speed} m/s</td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default WeatherTable;

// 2.

import React, { useState } from "react";

const WeatherTable = () => {
  const [city, setCity] = useState("");
  const [weatherData, setWeatherData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Step 1: Get Lat Long from City
  const getCoordinates = async (cityName) => {
    const res = await fetch(
      `https://geocoding-api.open-meteo.com/v1/search?name=${cityName}`
    );
    const data = await res.json();

    if (!data.results || data.results.length === 0) {
      alert("City not found");
      return null;
    }

    return {
      latitude: data.results[0].latitude,
      longitude: data.results[0].longitude,
    };
  };

  // Step 2: Get Weather Data
  const getWeather = async () => {
    if (!city) {
      alert("Please enter city name");
      return;
    }

    setLoading(true);

    const coords = await getCoordinates(city);

    if (!coords) {
      setLoading(false);
      return;
    }

    const { latitude, longitude } = coords;

    const url = `https://archive-api.open-meteo.com/v1/archive?latitude=${latitude}&longitude=${longitude}&start_date=2026-01-09&end_date=2026-04-27&hourly=temperature_2m`;

    const res = await fetch(url);
    const data = await res.json(); 

    const time = data.hourly.time;
    const temp = data.hourly.temperature_2m;

    const merged = time.map((t, i) => ({
      time: t,
      temp: temp[i],
    }));

    setWeatherData(merged);
    setLoading(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>🌤 Weather Data Table</h2>

      {/* Input */}
      <input
        type="text"
        placeholder="Enter city (e.g. Delhi)"
        value={city}
        onChange={(e) => setCity(e.target.value)}
        style={{ padding: "8px", marginRight: "10px" }}
      />

      <button onClick={getWeather} style={{ padding: "8px 15px" }}>
        Get Data
      </button>

      {/* Loader */}
      {loading && <p>Loading data...</p>}

      {/* Table */}
      {!loading && weatherData.length > 0 && (
        <table border="1" cellPadding="10" style={{ marginTop: "20px" }}>
          <thead>
            <tr>
              <th>Date Time</th>
              <th>Temperature (°C)</th>
            </tr>
          </thead>
          <tbody>
            {weatherData.map((item, index) => (
              <tr key={index}>
                <td>{item.time}</td>
                <td>{item.temp}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default WeatherTable;
